import React, {Component} from "react";
import {ButtonSpeaker,} from '../../helpers/rendererHelper'
import "./PlayerSuperSmall.css";
import {defineSpecificUrl, getBaseUrl} from "../../helpers/configHelper";
import ReactPlayer from "react-player";
import {MiniPause, MiniPlay} from "../Icon";
import Slider from "@mui/material/Slider";

const defaultImage = 'https://radiocover.storage5.infomaniak.com/static/defaultImage.svg';
const unavailable = 'https://radiocover.storage5.infomaniak.com/static/unavailable.svg';

export default class PlayerSuperSmall extends Component {

    constructor(props) {
        super(props);
        this.state = {
            autoplay: !!parseInt(props.autoplay),
            controls: false,
            display: defaultImage,
            error: false,
            isExtend: false,
            light: false,
            loaded: 0,
            locale: props.locale,
            muted: false,
            neverPlayed: true,
            playbackRate: 1.0,
            played: 0,
            playing: false,
            preview: props.preview,
            stationIndex: 0,
            stream: null,
            timeline: [],
            isHlsBuffered: props.isHlsBuffered,
            isDirectControl: props.isDirectControl,
            urlParam: props.tokens['token'] ? (props.url + '?token=' + props.tokens['token']) : props.url
        }
    }

    async componentDidMount() {
        this.init(this.state.urlParam);
    }

    init = url => {
        var config = defineSpecificUrl(url);
        this.setState({'url': 'temp.mp3', 'volume': 0.5, "stream": config.stations[0].streams[0]});
    }

    // Call at the creation or after load function
    // The config is not change here
    onPlayerReady = () => {
        if (!this.state.error && this.state.neverPlayed && this.state.stream.format === 'hls') {
            // Get the hls player, it's undefined if the stream is not a HLS stream
            this.hlsPlayer = this.player.getInternalPlayer('hls');
        }
    }

    handlePlay = () => {
        // First play
        if (this.state.stream.format === 'hls') {
            // reload HLS stream at the end
            this.setState({url: this.state.stream.url});
        } else {
            this.player.player.player.player.src = this.state.stream.url;
            this.player.player.player.player.load();
        }
        this.setState({playing: true});
    }

    handlePause = () => {
        // Stop loading
        if (this.state.stream.format === 'hls' && this.hlsPlayer) {
            this.hlsPlayer.stopLoad();
            // change the stream url for reload the right stream at the play
            this.setState({url: ''});
        } else {
            // Empty the src player to stop loading
            this.player.player.player.player.src = '';
            this.player.player.player.player.load();
        }
        this.setState({playing: false});
    }

    handleVolumeChange = (e, value) => {
        this.setState({muted: value === 0, volume: parseFloat(value)});
    }

    handleToggleMuted = () => {
        const isMuted = this.state.muted;
        if (!isMuted) {
            this.setState({volumeTemp: this.state.volume});
            this.handleVolumeChange(null, 0);
        } else {
            this.handleVolumeChange(null, this.state.volumeTemp);
        }
        this.setState({muted: !isMuted});
    }

    ref = player => {
        this.player = player;
    }

    render() {
        const {
            defaultVolume,
            display,
            fragment,
            light,
            muted,
            playbackRate,
            playing,
            playlist,
            url,
            volume
        } = this.state;
        if (!this.state.stream) {
            return <div/>;
        }


        document.body.style.backgroundColor = '#fff';

        function ButtonPlayPause(props) {
            return props.playing ?
                <MiniPause id="pause" onClick={props.onClickPause}
                           alt="pause"
                           color={props.color}/>
                :
                <MiniPlay id="play" onClick={props.onClickPlay}
                          alt="play"
                          color={props.color}/>;
        }

        return <div className='player-wrapper super-small-player'
                    style={{backgroundColor: '#202020', color: '#0098FF'}}>

            <div id="player-image">
                <img id="image" src={display}
                     alt="defaultImage"/>

            </div>

            <div id="player">


                <div id="author-container" className="marquee">
                    <p id="author">{getBaseUrl(this.state.urlParam)}</p>
                </div>
                <div id="controls">
                    <div id="player-buttons" className="buttons">
                        <ButtonPlayPause
                            onClickPlay={this.handlePlay}
                            onClickPause={this.handlePause}
                            color={'#FFFFFF'}
                            playing={playing}
                        />
                        <ButtonSpeaker
                            onClick={this.handleToggleMuted}
                            color={'#FFFFFF'}
                            muted={muted}
                        />

                        <Slider type='range' min={0} max={1} step={0.0000001} value={volume}
                                style={{color: '#FFFFFF'}}
                                defaultValue={defaultVolume}
                                id="volume"
                                onChange={this.handleVolumeChange}/>

                    </div>
                </div>


                <ReactPlayer
                    id="react-player"
                    ref={this.ref}
                    className='react-player'
                    url={url}
                    playing={playing}
                    light={light}
                    playbackRate={playbackRate}
                    volume={volume}
                    muted={muted}
                    onReady={this.onPlayerReady}
                    onProgress={e => {
                        if (display.includes('defaultUnavailable')) {
                            this.setState({display: defaultImage});
                        }
                    }}
                    onError={e => {
                        if (!this.player.player.player.player.src.includes('temp.mp3') && playing && !this.hlsPlayer) {
                            this.setState({display: unavailable});
                        }
                    }}
                    config={{
                        file: {
                            attributes: {
                                crossOrigin: "anonymous"
                            },
                            hlsOptions: {
                                // Taille du buffer déjà lu à garder en cache (en seconde)
                                backBufferLength: 0,
                                // Taille maximum du buffer pas encore lu à garder en cache (en seconde)
                                maxMaxBufferLength: 10,
                                // Nombre de seconde de décalage avec le live (en seconde)
                                liveSyncDuration: 10,
                                startPosition: 0
                            }
                        }
                    }}
                />
            </div>
        </div>;
    }
}
